module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subheader"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "offset": 3,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "user-name top-info"
  }, [_vm._v(_vm._s(_vm.profile.name))]), _vm._v(" "), _c('div', {
    staticClass: "user-address bottom-info"
  }, [_vm._v(_vm._s(_vm.profile.address))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "offset": 10,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "current-time top-info"
  }, [_vm._v(_vm._s(_vm.time) + _vm._s(_vm.period))]), _vm._v(" "), _c('div', {
    staticClass: "current-date bottom-info"
  }, [_vm._v(_vm._s(_vm.date))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c18b64a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubHeader.vue
// module id = 416
// module chunks = 23